import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ILayoutPart } from '../Shared/model/LayoutModel';
import { IResponseModel } from '../Shared/model/CommonModel';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    getParts(): Observable<any> {
        return this.http.get<any>(`${this.baseURL}/Layout/GetLayoutParts`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as any;
                return result;
            }),
            catchError(this.handleError));
    }

    saveLayoutParts(layoutPartsModel: ILayoutPart): Observable<IResponseModel> {
        return this.http.post<any>(`${this.baseURL}/Layout/SaveLayoutParts`, layoutPartsModel, { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<IResponseModel>) => res.body),
            catchError(this.handleError)
        );
    }

    deleteLayoutPart(id: number): Observable<IResponseModel> {
        return this.http.delete<any>(`${this.baseURL}/Layout/DeleteLayoutPart?partId=${id}`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as IResponseModel;
                return result;
            }),
            catchError(this.handleError));
    }

    getBoothAreasInLayOut(partId) {
        return this.http.get<any>(
            `${this.baseURL}/Layout/GetBoothAreasInLayOut?partId=${partId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getBuildingAreasInLayOut(partId) {
        return this.http.get<any>(
            `${this.baseURL}/Layout/GetBuildingAreasInLayOut?partId=${partId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getLayoutImages(partId) {
        return this.http.get<any>(
            `${this.baseURL}/Layout/GetLayoutImages?partId=${partId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getImages() {
        return this.http.get<any>(
            `${this.baseURL}/Layout/GetImagesForLayout`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    deleteBoothAreasInLayOut(boothId) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Layout/DeleteBoothAreasInLayOut?BoothId=` + boothId
        return this.http.post<any>(url, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    deleteBuildingAreasInLayOut(buildingId) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Layout/DeleteBuildingAreasInLayOut?buildingId=` + buildingId
        return this.http.post<any>(url, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    getLayoutFonts() {
        return this.http.get<any>(
            `${this.baseURL}/Layout/GetLayoutFonts`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    deleteImageAreasInLayOut(imagesId) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Layout/DeleteImagesInLayOut?imagesId=` + imagesId
        return this.http.post<any>(url, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    saveBoothAreasInLayOut(booths): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Layout/saveBoothAreasInLayOut`;
        return this.http.post<any>(url, booths, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    ChangeBoothNumber(boothUpdateData): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Layout/ChangeBoothNumber`;
        return this.http.post<any>(url, boothUpdateData, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    checkRentalExistForBoothNo(boothNumber) {
        return this.http.get<any>(
            `${this.baseURL}/Layout/CheckRentalExistForBoothNo?BoothNumber=${boothNumber}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    checkBoothNoExistInMarket(boothNumber) {
        return this.http.get<any>(
            `${this.baseURL}/Layout/CheckBoothNoExistInMarket?BoothNo=${boothNumber}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    saveBuildingAreasInLayOut(buildings): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Layout/SaveBuildingAreasInLayOut`;
        return this.http.post<any>(url, buildings, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    saveImageAreasInLayOut(images): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Layout/SaveLayoutImages`;
        return this.http.post<any>(url, images, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    saveDiagram(diagramData): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Layout/SaveLayoutDiagram`;
        return this.http.post<any>(url, diagramData, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    validateBoothNumber(boothNumber: string) {
        return this.http.get<boolean>(
            `${this.baseURL}/Layout/ValidateBoothNumber?boothNumber=${boothNumber}`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body as boolean),
            catchError(this.handleError)
        );
    }

    releaseBoothFromTemp(boothNumber: string): Observable<any> {
        const params = new HttpParams().set('boothNumber', boothNumber);
        return this.http.get<any>(`${this.baseURL}/Layout/ReleaseBoothFromTemp`,
            {
                params,
                observe: 'response'
            })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}